<script>
	import { onMount } from 'svelte';
	import { PUBLIC_SERVER_ENDPOINT } from '$env/static/public';
	import audio from '$lib/images/audio.svg';
	import play from '$lib/images/play.svg';
	import pause from '$lib/images/pause.svg';
	import { TTS } from '$lib/tts';

	export let className = '';
	export let content;
	export let title = 'Listen to your Soulprint';

	let isPlaying = false;
	let audioElement;
	let currentTime = 0;
	let duration = 0;
	let isFirstPlay = true;
	let src;

	// Toggle play/pause state
	function togglePlay() {
		if (isPlaying) {
			audioElement.pause();
		} else {
			audioElement.play();
			if (isFirstPlay) {
				isFirstPlay = false;
			}
		}
		isPlaying = !isPlaying;
	}

	// Update progress on `timeupdate` event
	function updateProgress() {
		currentTime = audioElement.currentTime;
		console.log(audioElement.duration);
		if (audio.duration == undefined) {
			duration = content.length * 0.0608;
		} else {
			duration = Math.round(audioElement.duration);
		}

		if (Math.round(currentTime) == Math.round(duration)) {
			togglePlay();
		}
		// duration = audioElement.duration;
	}

	// Seek to a specific time
	function seek(event) {
		const seekTime = (event.target.value / 100) * duration;
		audioElement.currentTime = seekTime;
	}

	// Format time as mm:ss
	function formatTime(time) {
		const minutes = Math.floor(time / 60)
			.toString()
			.padStart(2, '0');
		const seconds = Math.floor(time % 60)
			.toString()
			.padStart(2, '0');
		return `${minutes}:${seconds}`;
	}

	// Add event listener on mount
	onMount(() => {
		console.dir(content);
		let tts = new TTS(localStorage.getItem('token'));
		let encoded = tts.getCode(content);
		console.dir(encoded);
		src = tts.getAudioURL(encoded)
		audioElement.addEventListener('timeupdate', updateProgress);
	});
</script>

<button
	on:click={togglePlay}
	type="button"
	class={`rounded-md w-full bg-white/10  text-white shadow-gradient-border pl-4 pr-4 min-h-[54px] py-2.5 flex items-center gap-3 my-7 hover:bg-white/20 duration-150 ${className}`}
>
	{#if isFirstPlay}
		<div class="flex-shrink-0">
			<img src={audio} alt="audio" />
		</div>
		<div class="text-lg font-semibold flex-1 truncate text-left">{title}</div>
	{:else}
		<div class="flex items-center gap-2 flex-1 relative">
			<span class="text-[9px] -top-5 left-0 font-light absolute">{formatTime(currentTime)}</span>
			<input
				type="range"
				min="0"
				max="100"
				value={(currentTime / duration) * 100 || 0}
				on:input={seek}
				class="flex-1"
			/>
			<span class="text-[9px] -top-5 right-0 font-light absolute">{formatTime(duration)}</span>
		</div>
	{/if}

	<div class="flex-shrink-0 ml-auto">
		<img src={isPlaying ? pause : play} alt={isPlaying ? 'pause' : 'play'} />
	</div>
</button>

<audio bind:this={audioElement} {src} type="audio/aac"></audio>

<style scoped>
	/* Styling the range slider track */
	input[type='range'] {
		-webkit-appearance: none;
		width: 100%;
		height: 18px;
		background: rgba(255, 255, 255, 0.1);
		border-radius: 40px;
		outline: none;
		padding: 0;
		margin: 0;
		transition: background 0.3s;
	}

	/* Track on hover */
	input[type='range']:hover {
		background: rgba(255, 255, 255, 0.2);
	}

	/* Webkit-based browsers */
	input[type='range']::-webkit-slider-runnable-track {
		width: 100%;
		height: 18px;
		background: rgba(255, 255, 255, 0.1);
		border-radius: 40px;
	}

	input[type='range']::-webkit-slider-thumb {
		-webkit-appearance: none;
		height: 18px;
		width: 18px;
		background: white; /* Thumb color */
		border-radius: 50%; /* Make the thumb round */
		cursor: pointer;
		position: relative;
	}

	/* Firefox */
	input[type='range']::-moz-range-thumb {
		height: 18px;
		width: 18px;
		background: white;
		border-radius: 50%;
		cursor: pointer;
		border: none;
	}

	input[type='range']::-moz-range-track {
		height: 18px;
		background: rgba(255, 255, 255, 0.1);
		border-radius: 40px;
	}

	/* For IE */
	input[type='range']::-ms-track {
		width: 100%;
		height: 18px;
		border-radius: 50%;
	}

	input[type='range']::-ms-thumb {
		height: 18px;
		width: 18px;
		background: white;
		border-radius: 50%;
		cursor: pointer;
	}
</style>
